"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, } from "@/components/ui/carousel";
import { PlaceCard } from "./place-card";
import { HotelCard } from "./hotel-card";
import { Button } from "@/components/ui/button";
import classNames from "classnames";
import styles from "./styles.module.css";
import { formatURLDate } from "@travel/libs/shared/utils";
import { cn } from "@travel/lib/utils";
export function CollectionList(_a) {
    var className = _a.className, children = _a.children, type = _a.type, isCarousel = _a.isCarousel, _b = _a.items, items = _b === void 0 ? [] : _b, showMore = _a.showMore, _c = _a.maxBeforeShowMore, maxBeforeShowMore = _c === void 0 ? 4 : _c, _d = _a.columnsSmall, columnsSmall = _d === void 0 ? 1 : _d, _e = _a.columnsMedium, columnsMedium = _e === void 0 ? 2 : _e, _f = _a.columnsLarge, columnsLarge = _f === void 0 ? 3 : _f, _g = _a.columnsExtraLarge, columnsExtraLarge = _g === void 0 ? 4 : _g;
    var _h = __read(useState(false), 2), isShowingAll = _h[0], setIsShowingAll = _h[1];
    var minGridItems = showMore
        ? (items === null || items === void 0 ? void 0 : items.slice(0, maxBeforeShowMore)) || []
        : items || [];
    var gridItemsToRender = showMore && !isShowingAll ? minGridItems : items;
    var columns = {
        s: {
            1: "grid-cols-1",
            2: "grid-cols-2",
            3: "grid-cols-3",
            4: "grid-cols-4",
        },
        m: {
            1: "md:grid-cols-1",
            2: "md:grid-cols-2",
            3: "md:grid-cols-3",
            4: "md:grid-cols-4",
        },
        l: {
            1: "lg:grid-cols-1",
            2: "lg:grid-cols-2",
            3: "lg:grid-cols-3",
            4: "lg:grid-cols-4",
        },
        xl: {
            1: "xl:grid-cols-1",
            2: "xl:grid-cols-2",
            3: "xl:grid-cols-3",
            4: "xl:grid-cols-4",
        },
    };
    var _j = __read(useState(true), 2), isLocked = _j[0], setIsLocked = _j[1];
    return isCarousel ? (_jsx("div", { className: cn("w-[calc(100%_+_32px)] -ml-[16px] md:w-full  md:w-[calc(100%_+_16px)] md:-ml-[8px]", className), children: _jsxs(Carousel, { opts: {
                align: "start",
                loop: true,
                watchDrag: isLocked,
            }, className: "w-full", children: [_jsx(CarouselContent, { className: "ml-0", children: items.map(function (item, index) { return (_jsx(CarouselItem, { className: "pl-4 pb-2 max-w-[320px] md:max-w-full md:basis-1/2 lg:basis-1/3 xl:basis-1/4 grid @container @md:pl-2 @md:pr-2", children: children(item, index, setIsLocked) }, item.id)); }) }), _jsx(CarouselPrevious, { className: classNames("hidden lg:flex", styles["prev"]) }), _jsx(CarouselNext, { className: classNames("hidden lg:flex", styles["next"]) })] }) })) : (_jsxs("div", { className: cn("grid gap-8 items-center", className), children: [_jsx("div", { className: "grid gap-4 ".concat(columns.s[columnsSmall], " ").concat(columns.m[columnsMedium], " ").concat(columns.l[columnsLarge], " ").concat(columns.xl[columnsExtraLarge]), children: gridItemsToRender === null || gridItemsToRender === void 0 ? void 0 : gridItemsToRender.map(function (item, index) {
                    var _a;
                    return (_jsx("div", { className: classNames("grid", styles["item"], (_a = {},
                            _a[styles["last-s"]] = !isShowingAll && index === columnsSmall - 1,
                            _a[styles["last-m"]] = !isShowingAll && index === columnsMedium - 1,
                            _a[styles["last-l"]] = !isShowingAll && index === columnsLarge - 1,
                            _a[styles["last-xl"]] = !isShowingAll && index === columnsExtraLarge - 1,
                            _a)), children: _jsx("div", { className: "@container grid", children: children(item, index) }) }, item.id));
                }) }), showMore && minGridItems.length < items.length && (_jsxs(Button, { className: "mx-auto", variant: "outline", onClick: function () { return setIsShowingAll(!isShowingAll); }, children: ["Show ", isShowingAll ? "Less" : "More", type ? " ".concat(type) : ""] }))] }));
}
export function PlaceCollectionList(_a) {
    var checkIn = _a.checkIn, checkOut = _a.checkOut, _b = _a.roomCount, roomCount = _b === void 0 ? 1 : _b, _c = _a.adultCount, adultCount = _c === void 0 ? 2 : _c, _d = _a.childCount, childCount = _d === void 0 ? 0 : _d, baseURL = _a.baseURL, campaign = _a.campaign, affiliate = _a.affiliate, props = __rest(_a, ["checkIn", "checkOut", "roomCount", "adultCount", "childCount", "baseURL", "campaign", "affiliate"]);
    var params = new URLSearchParams({
        rooms: String(roomCount || 1),
        adults: String(adultCount || 2),
    });
    if (checkIn) {
        params.set("check-in", typeof checkIn === "string" ? checkIn : formatURLDate(checkIn));
    }
    if (checkOut) {
        params.set("check-out", typeof checkOut === "string" ? checkOut : formatURLDate(checkOut));
    }
    if (affiliate) {
        params.set("campaign", affiliate);
    }
    if (campaign) {
        params.set("cid", campaign);
    }
    return (_jsx(CollectionList, __assign({}, props, { type: "Cities", children: function (place) {
            var _a, _b, _c;
            return (_createElement(PlaceCard, __assign({}, place, { city: place.name, key: place.id, properties: place.propertyCount, currency: (_b = (_a = place.lowestPropertyPrice) === null || _a === void 0 ? void 0 : _a.currency) === null || _b === void 0 ? void 0 : _b.symbol, minPrice: (_c = place.lowestPropertyPrice) === null || _c === void 0 ? void 0 : _c.value, href: "".concat(baseURL || "", "/hotels/").concat(place.type, "/").concat(place.id, "?").concat(params.toString()) })));
        } })));
}
export function HotelCollectionList(_a) {
    var checkIn = _a.checkIn, checkOut = _a.checkOut, _b = _a.roomCount, roomCount = _b === void 0 ? 1 : _b, _c = _a.adultCount, adultCount = _c === void 0 ? 2 : _c, _d = _a.childCount, childCount = _d === void 0 ? 0 : _d, baseURL = _a.baseURL, campaign = _a.campaign, affiliate = _a.affiliate, sdk = _a.sdk, props = __rest(_a, ["checkIn", "checkOut", "roomCount", "adultCount", "childCount", "baseURL", "campaign", "affiliate", "sdk"]);
    var params = new URLSearchParams({
        rooms: String(roomCount || 1),
        adults: String(adultCount || 2),
    });
    if (checkIn) {
        params.set("check-in", typeof checkIn === "string" ? checkIn : formatURLDate(checkIn));
    }
    if (checkOut) {
        params.set("check-out", typeof checkOut === "string" ? checkOut : formatURLDate(checkOut));
    }
    if (affiliate) {
        params.set("campaign", affiliate);
    }
    if (campaign) {
        params.set("cid", campaign);
    }
    return (_jsx(CollectionList, __assign({}, props, { type: "Hotels", children: function (hotel, _, setIsLocked) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
            return (_jsx(HotelCard, { name: hotel.name, location: (_a = hotel.address) === null || _a === void 0 ? void 0 : _a.city, images: ((_b = hotel.images) === null || _b === void 0 ? void 0 : _b.length)
                    ? (_c = hotel.images) === null || _c === void 0 ? void 0 : _c.map(function (img) { return img.src; })
                    : ((_d = hotel.thumbnail) === null || _d === void 0 ? void 0 : _d.src)
                        ? [hotel.thumbnail.src]
                        : undefined, rating: hotel.reviewRating, starRating: hotel.starRating, currency: (_g = (_f = (_e = hotel === null || hotel === void 0 ? void 0 : hotel.price) === null || _e === void 0 ? void 0 : _e.display) === null || _f === void 0 ? void 0 : _f.currency) === null || _g === void 0 ? void 0 : _g.symbol, reviews: hotel.reviewCount, price: (_j = (_h = hotel.price) === null || _h === void 0 ? void 0 : _h.display) === null || _j === void 0 ? void 0 : _j.value, 
                //amenities={hotel.amenities}
                originalPrice: (_l = (_k = hotel.price) === null || _k === void 0 ? void 0 : _k.displayOriginal) === null || _l === void 0 ? void 0 : _l.value, total: (_o = (_m = hotel.price) === null || _m === void 0 ? void 0 : _m.displayTotal) === null || _o === void 0 ? void 0 : _o.value, betterPriceAvailable: (_p = hotel.price) === null || _p === void 0 ? void 0 : _p.hasBetterDeal, savingsPercentage: (_q = hotel.price) === null || _q === void 0 ? void 0 : _q.displaySavings, onCarouselPointerDown: function () { return setIsLocked === null || setIsLocked === void 0 ? void 0 : setIsLocked(false); }, onCarouselPointerUp: function () { return setIsLocked === null || setIsLocked === void 0 ? void 0 : setIsLocked(true); }, dark: props.hasBackground, sdk: sdk, alwaysShowMember: true, href: "".concat(baseURL || "", "/hotels/property/").concat(hotel.id, "?").concat(params.toString()) }));
        } })));
}
